import { Action } from "redux";
import { isType } from "typescript-fsa";

import * as types from "../actions/actionTypes";
import * as ajaxActions from "../actions/ajaxActions";

function actionTypeEndsInSuccess(type: string) {
  return type.substring(type.length - 8) === "_SUCCESS";
}

export default function ajaxStatusReducer(state: number = 0, action: any): any {

  if (isType(action, ajaxActions.beginAjaxCallAction)) {
    return state + 1;
  } else if (actionTypeEndsInSuccess(action.type)) {
    return state - 1;
  }

  if (state < 0) { state = 0; }

  return state;

}
